// extracted by mini-css-extract-plugin
export var fullWidthButton = "_ia-0";